// src/components/ShippingRecord/AddDisputePopin/index.tsx
import React from "react";
import DisputeFormContent from "./components/DisputeFormContent";
import { DisputeFormProvider } from "./context/DisputeFormContext";
import {
  Media,
  ShippingRecord,
  ShippingRecordDispute,
  ShippingRecordDisputeType,
} from "$types";

export type FormValues = {
  type: ShippingRecordDisputeType | null;
  text: string;
  linkedEntityId: string | null;
  media: Media[];
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  shippingRecord: ShippingRecord;
  shippingRecordDisputes: ShippingRecordDispute[];
  selectedDispute?: ShippingRecordDispute;
};

const DisputeForm: React.FC<Props> = ({
  onSubmit,
  onClose,
  shippingRecord,
  shippingRecordDisputes,
  selectedDispute,
  isOpen,
}) => {
  return (
    <DisputeFormProvider
      shippingRecord={shippingRecord}
      selectedDispute={selectedDispute}
      shippingRecordDisputes={shippingRecordDisputes}
      isOpen={isOpen}
      onClose={onClose}
    >
      <DisputeFormContent onSubmit={onSubmit} onClose={onClose} />
    </DisputeFormProvider>
  );
};

export default DisputeForm;
